import { mutation } from "@/services/lukita";
import { gql } from "@urql/core";

export default function createStatementsMutation({
  accountId,
  projectSlug,
  kind,
  blobsIds,
}) {
  return mutation(
    gql`
      mutation CreateStatementsMutation($input: CreateStatementsInput!) {
        createStatements(input: $input) {
          statements {
            __typename
            id
            fileName
            fileUrl
            numberOfPages
            createdAt
          }
        }
      }
    `,
    { input: { accountId, projectSlug, kind, blobsIds } },
  );
}
